// Polyfills
import '@babel/polyfill';
// CSS
import '../libs/timeline/style.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import 'assets/scss/styles.scss';
// logging
import Logger from 'config/logging';
// Sentry
import * as Sentry from '@sentry/browser';
// React/App
import React from 'react';
import ReactDOM from 'react-dom';
import configureStore, { history } from 'store';
import settings from 'settings';
import { setup as setupAxios } from 'library/axios-setup';
import AuthService from 'library/authService/auth-service';
import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import checkForUpdates from 'components/AppVersionCheck/CheckForUpdates';
import AppRouter from './app-router';

// Setup offline functionality
localStorage.setItem('CR_AppUpdateAvailable', 'false');
localStorage.setItem('CR_AppUpdateAcknowledged', 'false');
localStorage.setItem('CR_AppVersionUpdate', 'false');

// Sentry exception reporting
Sentry.init({
  dsn: settings.APP_CONFIG.sentryDsn,
  maxBreadcrumbs: 50,
  debug: true,

  environment: settings.APP_CONFIG.environment.toLowerCase(),
  release: settings.APP_CONFIG.sentryVersion
});
Sentry.setTags({
  app_version: settings.APP_CONFIG.versionSemantic,
  app_build: settings.APP_CONFIG.buildNumber
});

// No SW when local dev
if (settings.APP_CONFIG.environment.toLowerCase() !== 'local') {
  OfflinePluginRuntime.install({
    onUpdating: () => {
      // 1. A new update to the sw is being downloaded (ie a deploy was run (or a reload))
      caches.keys()
        .then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
      // eslint-disable-next-line no-console
      console.log('SW Event:', 'onUpdating');
    },
    onUpdateReady: () => {
      // 2. The new update is downloaded and waiting to activate
      // eslint-disable-next-line no-console
      console.log('SW Event:', 'onUpdateReady');

      // Tells to new SW activate immediately (normally it waits till all CR tabs are closed & reopened)
      navigator.serviceWorker.getRegistration(settings.BASE_URI())
        .then((registration) => {
          if (!registration || !registration.waiting) {
            Logger.warn(`Error activating service worker. Registration=${registration}; Registration Waiting=${registration.waiting}`);
            return;
          }

          registration.waiting.postMessage({
            action: 'skipWaiting'
          });
        });

      // OfflinePluginRuntime.applyUpdate();
    },
    onUpdated: () => {
      // 3. The new sw has been installed
      // We would now want a page refresh to get the new js/css
      // eslint-disable-next-line no-console
      console.log('SW Event:', 'onUpdated');

      localStorage.setItem('CR_AppUpdateAvailable', 'true');
      localStorage.setItem('CR_AppUpdateAcknowledged', 'false');
    },

    onUpdateFailed: () => {
      // eslint-disable-next-line no-console
      console.log('SW Event:', 'onUpdateFailed');
    }
  });
}
// Configure the store first so the Axios interceptor can dispatch into it (the
// Optimiser write-block dialog, FR-5.1).
const store = configureStore();
setupAxios(store);

// Disable the auto MSAL login as we want to use our custom login.
// Setting this value to true will direct the user to the Azure AD
// login page when the application is loaded.
const DO_NOT_LOGIN = true;

// Must wrap the app with runWithMsal to ensure a single instance of
// the app is loaded. Omitting the runWithMsal will cause MSAL to
// load the application in iFrames when it generates and refreshes
// the token. This will cause side effects where the application code
// will run multiple times.
AuthService.runWithMsal(
  () => {
    const AppRouterHOC = checkForUpdates(AppRouter);
    ReactDOM.render(<AppRouterHOC store={store} history={history} />, document.getElementById('root'));
  },
  DO_NOT_LOGIN
);
